import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState  , useMemo} from "react";
import {
  getSideBarfilesActions,
  setReinvestmentAction,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setTheReimbursementZone,
  setTheReimbursementState,
  setTheReimbursementRegion,
  setheReimbursementdesignationStatus,
  setTheReimbursementStateStatus,
  setTheReimbursementRange1,
  setTheReimbursementRange2,
    setTablePositionPersist
  
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import ReInvesmentEdit from "./ReInvesmentEdit";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import Select from "react-select";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import _ from "lodash";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ThumbsImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-13.svg";
import useDebouncedEffect from 'use-debounced-effect';

const ReInvestment = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const UserObjectData = useSelector((state) => state.users.UserData);

  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const state = useSelector((state) => state);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [sno, setsno] = useState(0);



    const TablePositionPersist = useSelector(
      (state) => state.PreviousPagePosition.TablePositionPersist
    )
  
  const [dtpageindex, setdtPageindex] = useState(
      TablePositionPersist?.ReimbursementlistRequestedPagelist?.page == undefined
        ? 1
        : TablePositionPersist.ReimbursementlistRequestedPagelist.page
    ); 
    const [search, setsearch] = useState(
      TablePositionPersist?.ReimbursementlistRequestedPagelist?.search == undefined ||
      TablePositionPersist?.ReimbursementlistRequestedPagelist?.search ==""
        ? ""
        : TablePositionPersist.ReimbursementlistRequestedPagelist.search
    ); 

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [filterForWhite, setFilters] = useState({ white_collar: 


    state.StateManagementOverallCall.Reimbursementdesignation?.value == ""?
    "":
    state.StateManagementOverallCall.Reimbursementdesignation?.value == 1 ?
    true:
    false


   });
  const HandleEMprole = (e) => {
    setdtPageindex(1);

    if (e != null) {
       dispatch(setheReimbursementdesignationStatus(e))
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(setheReimbursementdesignationStatus({value:"",label:"ALL"}))

      }
    }
  };

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.ReimbursementRange1);
  var gt = convert(state.StateManagementOverallCall.ReimbursementRange2);
  const [range, setrange] = useState(
    state.StateManagementOverallCall.ReimbursementRange1 == ""
      ? // [it, gt]
        []
      : [it, gt]
  );

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };




  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheReimbursementRange1(range[0]));
      dispatch(setTheReimbursementRange2(range[1]));
    }
  }, [range]);


  const FileterState = {
    status: state.StateManagementOverallCall.ReimbursementStatusState?.value,
  };
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];

  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.ReimbursementRegion

  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.ReimbursementZone

  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({
     zone: state.StateManagementOverallCall.ReimbursementZone.value,  
        state: state.StateManagementOverallCall.ReimbursementState.value,
 region: state.StateManagementOverallCall.ReimbursementRegion.value
 });
  const [multiselect, setMuliselect] = useState([
    state.StateManagementOverallCall.ReimbursementState
  ]);

 

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      selectVal: selectVal,
      data: data,
      white_collar: filterForWhite.white_collar,
      from_date: range[0],

      to_date: range[1],
    };
    dispatch(setReinvestmentAction(payload));
          dispatch(
                  setTablePositionPersist({
                    data: payload,
                    pageName: "ReimbursementlistRequestedPagelist",
                  })
                );
    
  }
  }, [selectVal, data, filterForWhite, range, dtpageindex , search]);

  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
  

  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,

      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      dispatch(setTheReimbursementZone({ value: "", label: "ALL" }));
      dispatch(setTheReimbursementRegion(selectedVal));

      setData({
        ...data,
        region: selectedVal.value,
      });


    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheReimbursementZone({ value: "", label: "ALL" }));
      dispatch(setTheReimbursementRegion({ value: "", label: "ALL" }));


      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });

      dispatch(setTheReimbursementZone(selectedVal));

    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheReimbursementZone({ value: "", label: "ALL" }));


    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

     

      dispatch(setTheReimbursementState(selectedVal));
      dispatch(setTheReimbursementZone({ value: "", label: "ALL" }));
      dispatch(setTheReimbursementRegion({ value: "", label: "ALL" }));



      setData({
        ...data,
        region: "",
        zone: "",
        state: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });


      dispatch(setTheReimbursementState({ value: "", label: "ALL" }));
      dispatch(setTheReimbursementZone({ value: "", label: "ALL" }));
      dispatch(setTheReimbursementRegion({ value: "", label: "ALL" }));


      setData({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);
 ///-----State----Input Changes
 const handleInputChange = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,

  });

};

///---Region-----------------
const handleInputRegion = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
  });
};
///----Zone---Name
const handleInputZone = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
  });
};

useDebouncedEffect(
() => {
    if (setSearchDebounance) {
        setSearched({
            ...SearchedVal,
            stateSearch: SearchDebounance.stateSearch,
            regionSearch: SearchDebounance.regionSearch,
            zoneSearch: SearchDebounance.zoneSearch,
        });

    }
},
500,
[SearchDebounance]
);
  const HandleLastPage = () => {
    if (
      currentPage != Math.ceil(state.reinvestmentCall.Total_Count / dtpagesize)
    ) {
      const pageEntries = {
        search: search,
        page_size: dtpagesize,
        page: Math.ceil(state.reinvestmentCall.Total_Count / dtpagesize),
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
        from_date: range[0],

        to_date: range[1],
      };
      dispatch(setReinvestmentAction(pageEntries));
      setCurrentPage(
        Math.ceil(state.reinvestmentCall.Total_Count / dtpagesize)
      );
      setNewpage(Math.ceil(state.reinvestmentCall.Total_Count / dtpagesize));
    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };



  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
           if(row.row.original.user_id.id != undefined && row.row.original.user_id.id != null){ 
          const userId = row.row.original.user_id.id;
          const lastFourDigits = userId.slice(-6);
          return <p>{lastFourDigits}</p>; 
           }
        },
      },
          {
      Header: filterForWhite.white_collar ? "User Name" : "Employee Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "CATEGORY",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.reason_type != null && row.row.original.reason_type != undefined ? (
              <span>{capitalizeFirstLetter(row.row.original.reason_type)}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },


    // {
    //   Header: "Place",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.to_place ? (
    //           <span>{row.row.original.to_place}</span>
    //         ) : (
    //           <span>----</span>
    //         )}
    //       </>
    //     );
    //   },
    // },
    // {
    //   Header: "From",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.from_place ? (
    //           <span>{row.row.original.from_place}</span>
    //         ) : (
    //           <span>----</span>
    //         )}
    //       </>
    //     );
    //   },
    // },

    // {
    //   Header: "Way Type",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.way_type ? (
    //           <span>{row.row.original.way_type}</span>
    //         ) : (
    //           <span>---</span>
    //         )}
    //       </>
    //     );
    //   },
    // },

    // {
    //   Header: "Wheeler Type",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.wheeler_type ? (
    //           <span>{row.row.original.wheeler_type}</span>
    //         ) : (
    //           <span>---</span>
    //         )}
    //       </>
    //     );
    //   },
    // },

    {
      Header: " Amount",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.amount ? (
              <span>{row.row.original.amount}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
           
              {row.row.original.status.toLowerCase() === "approved" ? (
                <button
                  className=" btn Status"
                  component="span"
                  style={{ cursor: "not-allowed" }}
                  onClick={(e) => {
                    setEmployeePop(true);
                    setEmployeeIDs(row.row.original.id);
                  }}
                >
                  <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                    <span className="ActionsList"> Approved </span>
                  </span>
                </button>
              ) : (
                <>
                  {row.row.original.status.toLowerCase() === "decline" ? (
                    <button
                      className=" btn Status"
                      component="span"
                      style={{ cursor: "not-allowed" }}
                      onClick={(e) => {
                        if (
                          !row.row.original.status.toLowerCase() == "approved"
                        ) {
                          setEmployeePop(true);
                          setEmployeeIDs(row.row.original.id);
                        }
                      }}
                    >
                      <span className="OuterActionSpan">
                      <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                        <span className="ActionsList"> Decline </span>
                      </span>
                    </button>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() === "pending" ? (
                        <button
                          className=" btn Status"
                          component="span"
                          onClick={(e) => {
                            setEmployeePop(true);
                            setEmployeeIDs(row.row.original.id);
                          }}
                        >
                          <span className="OuterActionSpan">
                          <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                            <span className="ActionsList"> Approve </span>
                          </span>
                        </button>
                      ) : null}
                    </>
                  )}
                </>
              )}
            </div>
          </>
        );
      },
    },
  ],
  [sno]
    );
  const ClearState = (Counts) => {
    if (Counts == 2) {
      dispatch(setTheReimbursementStateStatus({value:"",label:"All"}));

      SetSelectval({
        ...selectVal,

        status: "",
      });
      setdtPageindex(1);
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // console.log(Counts, values, sel, "Logs");
    //console.log(SelectedValues, "selectedvaluess");
    setdtPageindex(1);

    setSelected(sel);
    SetStates(true);
    dispatch(setTheReimbursementStateStatus(SelectedValues));

    if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,

        status: "completed",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,

        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };
  let objectArray = [];
  //console.log(state.NumberCounts.namerednder, "names");
  options.map((item) => {
    if (item.value == 1 && state.NumberCounts.namerednder == "") {
      objectArray.push({ value: item.value, label: item.label });
    } else if (
      item.value == 1 &&
      state.NumberCounts.namerednder == "completed"
    ) {
      objectArray.push({ value: item.value, label: item.label });
    } else if (item.value == 1 && state.NumberCounts.namerednder == "Decline") {
      objectArray.push({ value: item.value, label: item.label });
    }
  });

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '1083.344px', 'important');
      rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Reimbursement</h3>

          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>
          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px", zIndex: "9999" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>
          <div className="col-3">
            <label  class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList4}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Zone"
              //     : data.region == ""
              //     ? "without selected Region you can't select Zone"
              //     : "Search"
              // }
            />
          </div>

          <div className="col-3">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>

              {/* State Name */}
            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
            
            defaultValue={
              state.StateManagementOverallCall.ReimbursementRange1 == ""
                ? []
                : [
                    new Date(
                      state.StateManagementOverallCall.ReimbursementRange1
                    ),
                    new Date(
                      state.StateManagementOverallCall.ReimbursementRange2
                    ),
                  ]
            }

                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                onOpen={() => {
                  openMe()
                }}
  onClose={() => {
    CloseDateRange()
  }}
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {

                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    // if (diffDays === 30) {
                    //   // Since we are using inclusive range, difference should be 30 for 31 days
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else if (diffDays < 30) {
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else {
                    //   toast.error("Please select a range of exactly 31 days.", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //   });
                    // }

                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>

    
          <ReactTable
            data={state.reinvestmentCall.reinvestment}
            columns={columns}
            totalItems={state.reinvestmentCall.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.reinvestmentCall.Total_Count}
            values={state.StateManagementOverallCall.ReimbursementStatusState}
            options={options}
            Filter={true}
            count={count}
            ClearState={ClearState}
            placeHold={"All"}
            MakeCreate={false}
            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={state.StateManagementOverallCall.Reimbursementdesignation}
            HandleEMprole={HandleEMprole}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            ApproveRequestFilter={true}
                        searchVal={TablePositionPersist?.ReimbursementlistRequestedPagelist?.search == "" || TablePositionPersist?.ReimbursementlistRequestedPagelist?.search ==undefined? "":TablePositionPersist.ReimbursementlistRequestedPagelist.search}
              search_key={true}


          />
        </div>
      </div>

      {EmployeePop && EmployeeIDs != undefined ? (
        <ReInvesmentEdit
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          data={data}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          // Datestate={Datestate}
          from_date={range[0]}
          to_date={range[1]}
          search={search}
          white_collar={filterForWhite.white_collar}
        />
      ) : null}
    </>
  );
};

export default ReInvestment;
